import { AxisRange, AxisScale } from './widget-configuration';

export type AxisRangeErrorReturn =
  | { valid: true }
  | { valid: false; errorMessage: string; errorType: 'scale' | 'values' };

const isMinHigherThanOrEqualMax = (min: number | undefined, max: number | undefined) => {
  if (min === undefined || min === null || max === undefined || max === null) {
    return false;
  }

  return max <= min;
};

const isValidLogNumber = (number: number | undefined | null) => {
  if (number === undefined || number === null) {
    return true;
  }

  return number > 0;
};

export function isAxisRangeValid(
  axisRange?: AxisRange,
  axisScale?: AxisScale,
): AxisRangeErrorReturn {
  if (
    axisScale === 'logarithmic' &&
    (!isValidLogNumber(axisRange?.[0]) || !isValidLogNumber(axisRange?.[1]))
  ) {
    return {
      valid: false,
      errorMessage: 'Logarithmic axis requires values greater than zero.',
      errorType: 'scale',
    };
  }

  if (isMinHigherThanOrEqualMax(axisRange?.[0], axisRange?.[1])) {
    return {
      valid: false,
      errorMessage: 'Range maximum value must be greater than the minimum value.',
      errorType: 'values',
    };
  }

  return {
    valid: true,
  };
}
